import { boolean, number, object } from 'yup';
import { INVESTMENT_AMOUNT_CONSTANTS } from '@app/configs/investment';
const { MIN_AMOUNT, MAX_AMOUNT, STEP } = INVESTMENT_AMOUNT_CONSTANTS;
export const investmentFormValidationSchema = (maxAmount = MAX_AMOUNT) => object()
    .shape({
    investmentAmount: number()
        .required()
        .min(MIN_AMOUNT, 'min_amount')
        .max(maxAmount, 'max_amount')
        .test('multipleOf', 'amount_step', (value) => {
        if (!value)
            return true;
        return value % STEP === 0;
    }),
    generalConditions: boolean().oneOf([true]).required(),
    specialConditions: boolean().oneOf([true]).required(),
})
    .required();
